import React, { Component } from 'react'
import { Button, Modal, Input, message, Table } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

export default class RemittanceModal extends Component {
    state = {
        visible: false,
        data: [],
        selectedRowKeys: [],
        index: 0,
    }

    show = (ids, datas, index) => {
        (datas || []).map(el => {
            el.contractRemittanceApplicationId = String(el.contractRemittanceApplicationId);
        });
        this.setState({ 
            data: datas,
            visible: true, 
            index,
            selectedRowKeys: ids,
        })
    }

    hide = () => {
        this.setState({ 
            visible: false,
            data: [],
            selectedRowKeys: [],
            index: 0,
        })
    }

    confirm = () => {
        const { selectedRowKeys, index } = this.state;
        const { onChange } = this.props;
        onChange(selectedRowKeys, 'remittanceApplicationIds', index);
        this.hide();
    }

    getColumns = () => {
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            width: 120,
        },{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 120,
        },{
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
        },{
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
        },{
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            width: 120,
        },{
            title: '费用类型',
            dataIndex: 'expenseType',
            key: 'expenseType',
            width: 120,
        },{
            title: '开票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
            width: 120,
            render: text => text ? moment(text).format('YYYY-MM-DD') : ''
        },{
            title: '发票号',
            dataIndex: 'remark',
            key: 'remark',
            width: 120,
        },{
            title: '发票金额(不含税)',
            dataIndex: 'taxableAmount',
            key: 'taxableAmount',
            width: 120,
        },{
            title: '发票金额(含税总额)总金额',
            dataIndex: 'grossAmount',
            key: 'grossAmount',
            width: 120,
        },{
            title: '确认收款金额',
            dataIndex: 'receivingAmount',
            key: 'receivingAmount',
            width: 120,
        }];
        return columns
    }

    onSelectChange = (record, selected) => {
        const { contractRemittanceApplicationId } = record;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            list.push(contractRemittanceApplicationId);
        } else {
            list = list.filter(el => el != contractRemittanceApplicationId);
        }
        this.setState({ selectedRowKeys: list });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            changeRows.forEach(el => {
                list.push(el.contractRemittanceApplicationId);
            });
        } else {
            list = [];
        }
        this.setState({ selectedRowKeys: list });
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [];
        (data || []).forEach(d => {
            const { investigationId, records, manualRecords } = d;
            const list = (manualRecords || []).length === 0 ? records : manualRecords;
            const len = (list || []).length;
            if (len) {
                list.forEach((item, index) => {
                    dataSource.push({
                        ...d,
                        ...item,
                        investigationId,
                        rowSpan: index === 0 ? len : 0,
                        rowId: `${d.contractRemittanceApplicationId}-${item.contractBackRecordId}`
                    })
                });
            } else {
                dataSource.push({
                    ...d,
                    rowSpan: 1,
                    rowId: d.contractRemittanceApplicationId
                });
            }
        });
        return dataSource;
    }

    render() {
        const { visible, data, selectedRowKeys, loading } = this.state;
        const { isList = false } = this.props;
        const rowSelection = isList ? false : {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
        };
        const footer = isList ? <Button onClick={this.hide}>关闭</Button> : [
            <Button key="cancel" onClick={this.hide}>取消</Button>,
            <Button key="ok" type="primary" onClick={this.confirm}>确定</Button>,
        ];
        return (
            <Modal 
                title={`请款单号`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width={1000}
                bodyStyle={{ maxHeight: 600 }}
                footer={footer}
            >
                <div style={{ padding: '30px 20px' }}>
                    <Table
                        rowKey={record => record.contractRemittanceApplicationId}
                        rowSelection={rowSelection}
                        scroll={{ x: 800 }}
                        dataSource={this.getDataSource()}
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={false}
                    />
                </div>
            </Modal>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/RemittanceModal.js